// Models
import { UserMediaItem } from "../../profile/models/user-media.model";

export interface UserProfileLink {
  linkTitle: string;
  url: string;
}

export class UserProfile {
  /**
   * The user's profile description.
   * @type { string }
   */
  description?: string;

  /**
   * `true` if this model is the initial load of the user profile, or `false` otherwise.
   * @type { boolean }
   */
  initialLoad?: boolean;

  /**
   * The user's profile links.
   * @type { UserProfileLink[] }
   */
  links: UserProfileLink[] = [];

  constructor(userProfile?: UserProfile, initialLoad = true) {
    // Map response to properties
    this.description = userProfile?.description ?? '';
    this.initialLoad = initialLoad,
    this.links = userProfile?.links ?? [];
  }
}

export class UserProfileInfo {
  /**
   * The user's profile description.
   * @type { string }
   */
  description?: string;

  /**
   * The user's full name.
   * @type { string }
   */
  fullName?: string;

  /**
   * The user's profile links.
   * @type { UserProfileLink[] }
   */
  links: UserProfileLink[] = [];

  /**
   * The user's list of media assets.
   * @type { UserMediaItem[] }
   */
  mediaList: UserMediaItem[] = [];

  /**
   * The user's profile picture URI.
   * @type { string }
   */
  profilePictureUri?: string;

  /**
   * The user's username.
   * @type { string }
   */
  username?: string;

  constructor(userProfile?: any) {
    if (userProfile) {
      // Map response to properties
      this.description = userProfile.description;
      this.fullName = userProfile.fullName;
      this.links = userProfile.links;
      this.mediaList = userProfile.assets;
      this.profilePictureUri = userProfile.profilePictureUri;
      this.username = userProfile.username;
    }
  }
}
